<template>
 <div class="liveStreaming"  v-wechat-title="this.title">
     <div class="compere-stop">
       <splite-light></splite-light>
       <!-- {{liveStreamingRecommend}} -->


       <div class="compereMes">
           <div class="caption">
            <div class="split">
              <hr>
            </div>
            <div class="caption-name">直播已结束</div>
            <div class="split">
              <hr>
            </div>
          </div>
          <p class="comImg"><img :src="liveMsg.avatar" alt=""></p>
          <p class="comName">{{liveMsg.nickname}}</p>
          <p class="liveName">
          
            {{liveMsg.job}}
            </p>
          <div class="downloadMsg"  @click="toDownloadpage">
            <p>下载APP,观看更多精彩直播</p>
          </div>
       </div>
    
    </div>
     <!-- <div class="split1"></div> -->
     <hotRecommendBold ></hotRecommendBold>
     <!-- {{programStopRecommend}} -->
     <programcommenNew :commenProgram='programStopRecommend'></programcommenNew>
    <!-- <p class="linebtm"></p>
     <myfooter></myfooter> -->
    <!-- 弹窗 -->
    <div class="tipbox" v-show="istipshow=='1'" >
      <div class="tip">
        <p class="tiptitle">直播已结束,观看更多精彩内容</p>
        <p class='line'></p>
        <p class="tipbtn"><span class='close' @click="closeBtn()">取消</span><span @click="tipbtn()" class="btn">确定</span></p>
      </div>
    </div>
  </div>
</template>

<script>
// import lifeCommen from '../commen/lifeCommen'
// import myfooter from '../commen/myfooter'
import spliteLight from '../commen/spliteLight'
// import hotRecommendMiddle from '../commen/hotRecommendMiddle'
import cbct from '../../../static/js/base.js'
import toast from '../commen/toast.vue'
import programcommenNew from '../commen/programcommenNew'
import hotRecommendBold from '../commen/hotRecommendBold'

import qs from 'qs'
// let baseurl="http://api.dev.cbct.cn/"
export default {
  name: 'liveStreaming',
  props: {
  
  },
  data(){
    return {
      liveMsg:[],
      liveStreamingRecommend:[],
      number:'',
      type:'',
      title:"",
      appName:'-听见广播',
      programStopRecommend :[],
      istipshow:'1', 
      numberid:'', 
      islive:'',
      title1:'',  
    }
  },
  created(){
   let self=this
   self.number=self.$route.query.number;
   self.type=self.$route.query.type;
  //  var str="number="+6053462 +"&type="+2;
   self.$api.post(cbct.baseurl+"share/live",qs.stringify({
     'number':this.number,
     'type':this.type,
   })).then(function(res){
      if (res.c==cbct.code.successCode) {
        if(res.d.info.is_del == '1'){
              self.$router.push({
                path:'delPage'
              })
          }
        self.liveMsg=res.d.info;
        self.title=res.d.info.nickname+self.appName;
        if (res.d.recommend.length!='0') {
        self.programStopRecommend=res.d.recommend
          
        }else{
          self.istipshow = '0';
        }
        for(var i=0;i<res.d.recommend.length;i++){
           self.numberid =res.d.recommend[0].number;
           self.islive = res.d.recommend[0].is_live;
           self.title1 = res.d.recommend[0].title;
        }
        // if(res.d.recommend.length>0) {
        //   self.liveStreamingRecommend=res.d.recommend;
        // }else if(res.d.recommend.length==0){
        //   self.liveStreamingRecommend=['none'];
        // }
      }else{
            self.bus.$emit('toast',{show:true,title:res.m})

      }
   }).catch((res)=>{
      //  this.bus.$emit('toast',{show:true,title:'服务器错误'})
       console.log("生活直播结束页",res);
   });
  },
  methods:{
    toDownloadpage(){//点击下载
      this.$router.push({path:"downloadApp?isFrom=programRecorded"});
    },
    closeBtn:function(){
      this.istipshow='0';
    },
    tipbtn:function(){
      var self = this;
       this.$router.push({
          path:'programRecorded?type=1&live_id='+ self.numberid+'&isLive='+self.islive+'&title='+self.title1
        })
    }
  },

  components: {
      // lifeCommen,
      // myfooter,
      spliteLight,
      // hotRecommendMiddle,
      programcommenNew,
      hotRecommendBold

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
*{
  margin: 0;
  padding: 0;
}
/* 弹窗tip */
.tipbox{
  position: fixed;
  top:0;
  left:0;
  width: 100%;
  height: 100%;
  background:rgba(3,3,3,0.5);
  z-index: 101;
}
.tip{

  width:6rem;
  height:2.9rem;
  background:rgba(255,255,255,1);
  border-radius:.16rem;
  margin: 55% auto 0;
}
.tiptitle{
  height: 1.84rem;
  line-height: 1.84rem;
  font-size: .34rem;
  color: #333;
  font-weight: 600;
}
.line{
  width: 100%;
  height: 1px;
  background: rgba(0, 0, 0, .2);
}
.tipbtn{
  display: flex;
}
.close{
  width: 3rem;
  height: 1.04rem;
  text-align: center;
  line-height: 1.04rem;
  font-size: .32rem;
  font-weight: 500;
  color: rgba(0,0,0,.5);
}
.btn{
   width: 2.99rem;
  height: 1.04rem;
  font-weight: 500;
  text-align: center;
  line-height: 1.04rem;
  font-size: .32rem;
  color: #4473E1;
  border-left: 0.01rem solid ;
  border-left-color: rgba(0, 0, 0, .2);
}
.liveStreaming{
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  /* border: solid 1px red; */
  
} 
.compere-stop{
  width: 100%;
  box-sizing: border-box;
}
.compereMes{
  /* height:3.83rem; */
  width: 100%; 
  /* font-family:PingFangSC-Regular; */
  font-weight:400;
}
.caption{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 2rem;
}
.split{
  flex-grow: 1;
}
.split hr{
    width:.62rem;
    height:0.01rem;
    background:rgba(0,0,0,.8);
    /* border: none;
    border-top: 2px solid rgba(216,216,216,1); */
    margin-top: 0.88rem;

}
.caption-name{
  min-width:1.8rem;
  padding: 0 0.2rem;
  height:0.59rem;
  font-size:0.36rem;
  font-weight:500;
  line-height:0.59rem;
  margin-top: 0.88rem;
  color: rgba(0, 0, 0, .79);

}
.comImg{
  width: 3.42rem;
  height: 2.02rem;
  background: url('../../assets/comImgbg.png') no-repeat;
  background-size: 100% 100%;
  margin: auto;
  text-align: center; 
  margin-top: 0.47rem;
}
.comImg img{
  width: 2.02rem;
  height: 2.02rem;
  border-radius: 100%;
  margin: 0 auto;
  text-align: center;
}
.comName{
 
  box-sizing: border-box;
  margin: 0.33rem auto 0.14rem;
  text-align: center;
  font-size:0.36rem;
  color:rgba(0,0,0,.79);
  font-weight: 500;
}
.liveName{
   width: 100%;
   box-sizing: border-box;
   display: inline-block;
  text-align: center;
  margin: 0 auto;
  font-size: 0.3rem;
  color:rgba(0,0,0,.48);
  opacity: .49;
  font-weight:400;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp:2;
  -webkit-box-orient: vertical;
}
.downloadMsg{
box-sizing: border-box;
}
.downloadMsg p{
  width: 6.1rem;
  height: .96rem;
  background: #EB4C4C;
  text-align: center;
  line-height: .96rem;
  color: #fff;
  font-size: .3rem;
  margin:0.68rem auto;
  border-radius: 1rem;

}
.downloadMsg p img{
  width: 100%;
  height: 100%;
}
.split1{
width:7.5rem;
height:0.3rem;
background:rgba(0,0,0,1);
opacity:0.04;
}
.linebtm{
  height: .75rem;
  width: 100%;
}


</style>
